import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routesP = [{
    path: '/',
    name: 'pc',
    component: () => import('@/components/pc'),
    redirect: '/',
    children: [{
        path: '/',
        name: 'index',
        component: () => import('@/views/pc/index')
      },
      {
        path: '/product-erp',
        name: 'productErp',
        component: () => import('@/views/pc/product-erp')
      },
      {
        path: 'product-member',
        name: 'productMember',
        component: () => import('@/views/pc/product-member')
      },
      {
        path: 'product-health',
        name: 'productHealth',
        component: () => import('@/views/pc/product-health')
      },
      {
        path: 'product-ncd',
        name: 'productNcd',
        component: () => import('@/views/pc/product-ncd')
      },
      {
        path: 'product-check',
        name: 'productCheck',
        component: () => import('@/views/pc/product-check')
      },
      {
        path: 'product-educat',
        name: 'productEducat',
        component: () => import('@/views/pc/product-educat')
      }, {
        path: '/solve',
        name: 'solve',
        component: () => import('@/views/pc/solve')
      }, {
        path: '/service',
        name: 'service',
        component: () => import('@/views/pc/service')
      }, {
        path: '/about',
        name: 'about',
        component: () => import('@/views/pc/about')
      }, {
        path: '/case',
        name: 'case',
        component: () => import('@/views/pc/case')
      }
    ]
  }, {
    path: '/try',
    name: 'Try',
    component: () => import('@/views/pc/try')
  }, {
    path: '/step',
    name: 'Step',
    component: () => import('@/views/pc/step')
  },
  // 404 page must be placed at the end !!!
  {
    path: '*',
    component: () => import('@/views/404')
  }
]


const routesM = [{
    path: '/',
    name: 'mobile',
    component: () => import('@/components/mobile'),
    redirect: '/',
    children: [{
        path: '/',
        name: 'index',
        component: () => import('@/views/mobile/index')
      },
      {
        path: '/product-erp',
        name: 'productErp',
        component: () => import('@/views/mobile/product-erp')
      },
      {
        path: 'product-member',
        name: 'productMember',
        component: () => import('@/views/mobile/product-member')
      },
      {
        path: 'product-health',
        name: 'productHealth',
        component: () => import('@/views/mobile/product-health')
      }, {
        path: 'product-ncd',
        name: 'productNcd',
        component: () => import('@/views/mobile/product-ncd')
      }, {
        path: 'product-educat',
        name: 'productEducat',
        component: () => import('@/views/mobile/product-educat')
      },
      {
        path: 'product-check',
        name: 'productCheck',
        component: () => import('@/views/mobile/product-check')
      }, {
        path: '/solve',
        name: 'solve',
        component: () => import('@/views/mobile/solve')
      }, {
        path: '/service',
        name: 'service',
        component: () => import('@/views/mobile/service')
      }, {
        path: '/about',
        name: 'about',
        component: () => import('@/views/mobile/about')
      }, {
        path: '/case',
        name: 'case',
        component: () => import('@/views/mobile/case')
      }, {
        path: '/try',
        name: 'Try',
        component: () => import('@/views/mobile/try')
      }, {
        path: '/step',
        name: 'Step',
        component: () => import('@/views/mobile/step')
      },
    ]
  },
  // 404 page must be placed at the end !!!
  {
    path: '*',
    component: () => import('@/views/404')
  }
]

var routes = [];
if ((navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i))) {
  routes = routesM
} else {
  routes = routesP
}


const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return {
        x: 0,
        y: 0
      }
    }
  }
})

export default router